import { render } from "./AllAppointmentDays.vue?vue&type=template&id=4ff55685&scoped=true"
import script from "./AllAppointmentDays.vue?vue&type=script&lang=js"
export * from "./AllAppointmentDays.vue?vue&type=script&lang=js"

import "./AllAppointmentDays.vue?vue&type=style&index=0&id=4ff55685&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff55685"]])

export default __exports__